module.exports = __webpack_public_path__ + "img/text-first.6cc29d49.png";